import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import PlayerJoin from "@/pages/PlayerJoin";
import PlayerGame from "@/pages/PlayerGame";
import Host from "@/pages/Host";
import AuthPage from "@/pages/admin/AuthPage";
import Dashboard from "@/pages/admin/Dashboard";
import QuizBuilder from "@/pages/admin/QuizBuilder";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PlayerJoin />} />
            <Route path="/join" element={<PlayerJoin />} />
            <Route path="/play" element={<PlayerGame />} />
            <Route path="/admin/login" element={<AuthPage mode="login" />} />
            <Route path="/admin/register" element={<AuthPage mode="register" />} />
            <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/quiz/:id" element={<ProtectedRoute><QuizBuilder /></ProtectedRoute>} />
            <Route path="/host/:gameId" element={<ProtectedRoute><Host /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
